module.exports = __webpack_public_path__ + "static/media/support_icon_white.ea056c29.svg";